// extracted by mini-css-extract-plugin
export default {"Return":"Return_Return__BomdM","detail":"Return_detail__Tqz7b"};